module.exports = __webpack_public_path__ + "static/media/postgresql.95ea0ccc.svg";